import { render, staticRenderFns } from "./MyAssociation.vue?vue&type=template&id=8de56100&scoped=true&"
import script from "./MyAssociation.vue?vue&type=script&lang=js&"
export * from "./MyAssociation.vue?vue&type=script&lang=js&"
import style0 from "./MyAssociation.vue?vue&type=style&index=0&id=8de56100&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de56100",
  null
  
)

export default component.exports